import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/conspostratamiento";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllConspostratamientoByTax(params.tratamientoId);
}

export function ConspostratamientoList(props) {
  const [conspostratamientoList, setConspostratamiento] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllConspostratamientoByTax(props.id).then(setConspostratamiento).catch(console.log);
  }, [props.id]);

  return (

    <>
      {conspostratamientoList?.length ? (
        <ul className="entrenamiento cpt-list">
            {conspostratamientoList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(a.meta.metaFecha);
                const dateB = new Date(b.meta.metaFecha);
                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((conspostratamiento) => (
                <li key={conspostratamiento.id}>
                  <NavLink className="capitalize" to={`${props.id}/seguimiento/consulta-post-tratamiento/${conspostratamiento.id}`}>{`${FormatDate(conspostratamiento.meta.metaFecha)} - ${conspostratamiento.meta.conspostTipo}`}</NavLink>
                </li>
              ))}
          </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function ConspostratamientoListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Consulta Post-Tratamiento</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia') || props.userRole.includes('medicina')) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}